import { Box, Button } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import Search from "../assets/search.png";
import News from "../helpercomponents/news";
import SearchModal from "../helpercomponents/searchModal";
import appstore from "../store/appstore";
import Navbar from "./navbar";
import Sharecontentmodal from "./sharecontentmodal";
import Subscribing from "./subscribing";
const Newsletter = () => {
  const [isShareModalOpen, setShareModalOpen] = useState(false);
  const [isMobileview, setIsMobileView] = useState(false);
  const { isSubscribed } = appstore();
  const [open, setOpen] = useState(false);
  const [allNews, setAllnews] = useState([]);
  const [searchBoxvalue, setSearchBoxvalue] = useState("");
  const [sharingLink, setSharingLink] = useState("");
  const [unfilteredNews, setUnfilteredNews] = useState([]);
  const [currentButton, setCurrentButton] = useState("Latest");
  const [allfilter, seAllfilter] = useState(["Latest", "Oldest"]);

  const fetchNewsLetter = async (id) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: "https://simulyst.com/backend/newsletters",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await axios.request(config);
    if (id) {
      setAllnews(response?.data?.filter((e) => e?.id == id));
      setUnfilteredNews(response?.data);
    } else {
      setAllnews(response?.data);
      setUnfilteredNews(response?.data);
    }
  };
  const handlesearch = async (e) => {
    const newArray = [];
    setSearchBoxvalue(e);
    if (!e) {
      setAllnews(unfilteredNews);
      return;
    }
    unfilteredNews.map((el) => {
      if (el.heading.includes(e)) {
        newArray.push(el);
      }
    });
    setAllnews(newArray);
  };
  React.useEffect(() => {
    if (window && window.innerWidth) {
      if (window.innerWidth < 930) {
        setIsMobileView(true);
      } else {
        setIsMobileView(false);
      }
    }
    const updateScreenWidth = () => {
      if (window.innerWidth < 930) {
        setIsMobileView(true);
      } else {
        setIsMobileView(false);
      }
    };
    window.addEventListener("resize", updateScreenWidth);
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get("id");
    if (myParam) {
      fetchNewsLetter(myParam);
    } else {
      console.log("f");
      fetchNewsLetter();
    }
    return () => {
      window.removeEventListener("resize", updateScreenWidth);
    };
  }, []);
  return (
    <>
      {" "}
      <Navbar />
      <Box style={{ background: "#fafafa", width: "100%" }}>
        {" "}
        <SearchModal
          title={"Search for Newsletters"}
          setOpen={setOpen}
          open={open}
          handlesearch={handlesearch}
          searchBoxvalue={searchBoxvalue}
        />
        <Box
          width={"90%"}
          display={isMobileview ? "none" : "flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
          margin={"auto"}
          marginTop={"10px"}
          // paddingLeft={"15px"}
          // paddingRight={"15px"}
        >
          <Box>{currentButton}</Box>
          <Box display={"flex"} gap={"8px"}>
            {allfilter.map((el) => {
              return (
                <Button
                  className="item"
                  style={{
                    textTransform: "none",
                    // background: "#F5EAFA",
                    // color: "#C789E4",
                    // height: "35px",
                  }}
                  sx={{
                    background: currentButton == el ? "#F5EAFA" : "",
                    color: currentButton == el ? "#C789E4" : "grey",
                  }}
                  onClick={() => {
                    setCurrentButton(el);
                  }}
                  disableElevation
                >
                  {el}
                </Button>
              );
            })}
          </Box>
        </Box>
        <Box
          display={isMobileview ? "flex" : "none"}
          // border={"1px solid red"}
          height={"53px"}
          fontSize={"22px"}
          paddingLeft={"5%"}
          paddingRight={"5%"}
          marginTop={"3%"}
          // boxShadow={1}
          fontWeight={500}
          justifyContent={"space-between"}
          // style={{ borderBottom: "linear-gradient(45deg, purple, orange)" }}
          borderBottom="4px solid transparent"
          // borderImage="linear-gradient(45deg, purple, orange) 1"
          position={"relative"}
          // borderBottom={"linear-gradient(45deg, purple, orange)"}
        >
          <Box
            style={{
              position: "absolute",
              left: 0,
              bottom: 0,
              width: "50%",
              height: "1.5px",
              background: "linear-gradient(167deg, #ffffff, #eec9ff)",
            }}
          ></Box>
          <Box
            style={{
              position: "absolute",
              right: 0,
              bottom: 0,
              width: "50%",
              height: "1.5px",
              background: "linear-gradient(244deg, #ffffff, #eec9ff)",
            }}
          ></Box>
          Newsletter{" "}
          <img
            src={Search}
            style={{ cursor: "pointer" }}
            width={"24px"}
            height={"24px"}
            onClick={() => {
              setOpen(true);
            }}
          />
        </Box>
        <Box
          display={isMobileview ? "flex" : "none"}
          gap={"8px"}
          justifyContent={"end"}
        >
          {allfilter.map((el) => {
            return (
              <Button
                className="item"
                style={{
                  textTransform: "none",
                  // background: "#F5EAFA",
                  // color: "#C789E4",
                  // height: "35px",
                }}
                sx={{
                  background: currentButton == el ? "#F5EAFA" : "",
                  color: currentButton == el ? "#C789E4" : "grey",
                }}
                onClick={() => {
                  setCurrentButton(el);
                }}
                disableElevation
              >
                {el}
              </Button>
            );
          })}
        </Box>
        {isSubscribed ? (
          <Box sx={{ width: isMobileview ? "100%" : "70%", margin: "auto" }}>
            {currentButton == "Latest" &&
              allNews
                .sort((b, e) => new Date(e.created_at) - new Date(b.created_at))
                ?.map((el) => {
                  return (
                    <News
                      img={el?.image}
                      heading={el?.heading}
                      detail={el?.sub_description}
                      htmlContent={el?.contentUrl}
                      time={el?.created_at}
                      isMobileview={isMobileview}
                      edition={el?.edition}
                      setShareModalOpen={setShareModalOpen}
                      setSharingLink={setSharingLink}
                      id={el?.id}
                    />
                  );
                })}
            {currentButton == "Oldest" &&
              allNews
                .sort((e, b) => new Date(e.created_at) - new Date(b.created_at))
                ?.map((el) => {
                  return (
                    <News
                      img={el?.image}
                      heading={el?.heading}
                      detail={el?.sub_description}
                      htmlContent={el?.contentUrl}
                      time={el?.created_at}
                      isMobileview={isMobileview}
                      edition={el?.edition}
                      setShareModalOpen={setShareModalOpen}
                      setSharingLink={setSharingLink}
                      id={el?.id}
                    />
                  );
                })}

            {/* <News
          img={
            "https://images.ctfassets.net/ut7rzv8yehpf/1DhC3uX3EeKnjU02LWyTXH/9c82e6ae82662ed5903eafb40d888d90/8_Main_Types_of_Heart_Disease.jpg?w=1800&h=900&fl=progressive&q=50&fm=jpg"
          }
          heading={" Comprehensive Updates and Healthcare Statistics"}
          detail={`Stay informed about the latest developments in neurology, urology,
                    oncology, and many more, along with key statistics related to the
                    healthcare sector. This edition offers healthcare professionals
                    important insights and data-driven information to enhance their
                    research and career advancement.`}
          time={"11 Dec 2025"}
          isMobileview={isMobileview}
        /> */}
          </Box>
        ) : (
          <Box sx={{ width: isMobileview ? "100%" : "70%", margin: "auto" }}>
            {currentButton == "Latest" &&
              allNews
                .sort((b, e) => new Date(e.created_at) - new Date(b.created_at))
                ?.map((el, inx) => {
                  if (inx <= 3) {
                    return (
                      <News
                        img={el?.image}
                        heading={el?.heading}
                        detail={el?.sub_description}
                        htmlContent={el?.contentUrl}
                        time={el?.created_at}
                        isMobileview={isMobileview}
                        edition={el?.edition}
                        setShareModalOpen={setShareModalOpen}
                        setSharingLink={setSharingLink}
                        id={el?.id}
                      />
                    );
                  }
                })}
            {currentButton == "Oldest" &&
              allNews
                .sort((e, b) => new Date(e.created_at) - new Date(b.created_at))
                ?.map((el, inx) => {
                  if (inx <= 3) {
                    return (
                      <News
                        img={el?.image}
                        heading={el?.heading}
                        detail={el?.sub_description}
                        htmlContent={el?.contentUrl}
                        time={el?.created_at}
                        isMobileview={isMobileview}
                        edition={el?.edition}
                        setShareModalOpen={setShareModalOpen}
                        setSharingLink={setSharingLink}
                        id={el?.id}
                      />
                    );
                  }
                })}

            {/* <News
          img={
            "https://images.ctfassets.net/ut7rzv8yehpf/1DhC3uX3EeKnjU02LWyTXH/9c82e6ae82662ed5903eafb40d888d90/8_Main_Types_of_Heart_Disease.jpg?w=1800&h=900&fl=progressive&q=50&fm=jpg"
          }
          heading={" Comprehensive Updates and Healthcare Statistics"}
          detail={`Stay informed about the latest developments in neurology, urology,
                    oncology, and many more, along with key statistics related to the
                    healthcare sector. This edition offers healthcare professionals
                    important insights and data-driven information to enhance their
                    research and career advancement.`}
          time={"11 Dec 2025"}
          isMobileview={isMobileview}
        /> */}
          </Box>
        )}
      </Box>
      <Subscribing />
      <Sharecontentmodal
        isShareModalOpen={isShareModalOpen}
        setShareModalOpen={setShareModalOpen}
        ModuleName={"Newsletter"}
        link={sharingLink}
        isMobileview={isMobileview}
      />
    </>
  );
};

export default Newsletter;
